__turbopack_context__.v({
  "backdrop": "style-module-scss-module__ZnD4bq__backdrop",
  "content": "style-module-scss-module__ZnD4bq__content",
  "description": "style-module-scss-module__ZnD4bq__description",
  "eyebrow": "style-module-scss-module__ZnD4bq__eyebrow",
  "heroImage": "style-module-scss-module__ZnD4bq__heroImage",
  "result": "style-module-scss-module__ZnD4bq__result",
  "title": "style-module-scss-module__ZnD4bq__title",
});
